import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-[#121212] border-t border-white/10 shadow-lg" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 text-blue-400 shrink-0 mt-0.5" />
          <p className="text-zinc-300 text-sm">
            We use cookies to analyze site traffic and improve your experience. 
            By clicking "Accept", you consent to our use of cookies.{" "}
            <a href="/terms" className="text-blue-400 hover:text-blue-300 underline">
              Learn more
            </a>
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <Button
            variant="ghost"
            size="sm"
            onClick={declineCookies}
            className="text-zinc-400 hover:text-white"
          >
            Decline
          </Button>
          <Button
            size="sm"
            onClick={acceptCookies}
            className="bg-blue-600 hover:bg-blue-500 text-white"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
